import React from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

import "./ReportPage.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

function ReportPage() {
  // BAR CHART DATA
  const surplusData = {
    labels: ["Oct 5", "Oct 6", "Oct 7", "Oct 8"],
    datasets: [
      {
        label: "Surplus Quantity (Plates/Kg)",
        data: [10, 20, 25, 15],
        backgroundColor: "#14b8a6",
      },
    ],
  };

  // PIE CHART DATA
  const foodTypeData = {
    labels: ["Rice & Curry", "Bakery Items", "Vegetables"],
    datasets: [
      {
        data: [40, 25, 35],
        backgroundColor: ["#1e3a8a", "#06b6d4", "#16a34a"],
      },
    ],
  };

  return (
    <div className="report-container">
      <h1 className="report-title">SaveBite Analytics Dashboard</h1>

      {/* CHARTS ROW */}
      <div className="charts-row">
        <div className="card chart-card">
          <h2>Surplus Quantity Per Day</h2>
          <Bar data={surplusData} />
        </div>

        <div className="card chart-card">
          <h2>Food Type Distribution</h2>
          <Pie data={foodTypeData} />
        </div>
      </div>

      {/* TABLE */}
      <div className="card">
        <h2>Donations Collected by NGOs</h2>

        <table className="report-table">
          <thead>
            <tr>
              <th>Hotel Name</th>
              <th>Date</th>
              <th>Food Type</th>
              <th>Quantity</th>
              <th>Collected By</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Hotel Sunshine</td>
              <td>2025-10-08</td>
              <td>Rice & Curry</td>
              <td>15 Plates</td>
              <td>NGO Helping Hands</td>
            </tr>
            <tr>
              <td>Hotel BlueSky</td>
              <td>2025-10-08</td>
              <td>Bakery Items</td>
              <td>5 Kg</td>
              <td>NGO Food For All</td>
            </tr>
            <tr>
              <td>Hotel GreenLeaf</td>
              <td>2025-10-07</td>
              <td>Vegetables</td>
              <td>20 Kg</td>
              <td>NGO Helping Hands</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReportPage;